/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Language_LabelInputs */



/**
* | output |
* | --- |
* | "OCR Language" |
*
* @param {Ocr_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_language_label = /** @type {((inputs?: Ocr_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue OCR")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Sprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua OCR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Язык OCR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCR言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Idioma OCR")
	return /** @type {LocalizedString} */ ("OCR Language")
});